<div class="row">
    <div class="col-lg-12 cp margin-top-12">
        <div class="promp-align">
            <p>
                You have no pending follower requests.
            </p>
        </div>
    </div>
</div>